import { CardSearch, ConfirmationModal, ExportData, PageBodyHeader, ReportModal, Table, TableHeadElement } from "../../component";
import { useEffect, useState } from "react";
import { UrlTypes, generalObj } from "../../constant/object_types";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { checkStoreByStoreIdUserId, fetchProductOrderParentListReport, fetchProductParentOrder } from "../../action/generalFunc";
import { toast } from "react-toastify";

const VendorProductList = () => {

    const [productList, setProductList] = useState<generalObj[]>([]);

    const [searchText, setSearchText] = useState<string>("");
    const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState<boolean>(false);
    const [itemToDelete, setItemToDelete] = useState<generalObj | null>(null);
    const [openReportModal, setOpenReportModal] = useState<boolean>(false);
    const [exportType, setExportType] = useState<string | null>(null);
    const [storeName, setStoreName] = useState<string>("");
    const [rangeParam, setRangeParam] = useState<string | null>("");

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (!account || !account.isAuthenticated || !id) return;
        (async () => {
            const queryParameters = new URLSearchParams(window.location.search)
            setModalLoading(true)
            let result = await checkStoreByStoreIdUserId(account.token, id, account.id);
            if (!result) {
                window.history.back();
            }else {
                setStoreName(`${result.data.store_data.name} - ${result.data.store_data.organization}`)
            }
            (async () => {
                let order_result;
                if (queryParameters.size > 0 && queryParameters.get('range')) {
                    let range = queryParameters.get('range');
                    order_result = await fetchProductParentOrder(account.token, id, account.id, range)
                    setRangeParam(range);
                }else {
                    order_result = await fetchProductParentOrder(account.token, id, account.id)
                }
                if (!order_result) {
                    window.history.back();
                }
                setProductList(order_result);
                setModalLoading(false)
            })();
            
        })();
    }, [account, setModalLoading, id]);

    const onDelete = async () => {
        if (!account || !itemToDelete) return;
        setModalLoading(true);
        let result = true //await deleteUser(account.token, itemToDelete.id);
        if (result) {
            //toast(result.message);
            toast("simulating delete");
            setProductList((prevProductList) => {
                return (
                    prevProductList.filter((item) => item.id !== itemToDelete.id)
                )
            });
        }
        setItemToDelete(null);
        setOpenDeleteConfirmation(false)
        setModalLoading(false)
    }

    const onSearch = (val:string) => {
        let new_val = val.toLowerCase()
        setProductList((prevProductList) => {
            return (
                prevProductList.filter((item) => {
                    if (item.product.toLowerCase().includes(new_val) || new_val.includes(item.size) || new_val.includes(item.quantity) || new_val.includes(item.open_stock) || new_val.includes(item.close_stock) || new_val.includes(item.ros) || new_val.includes(item.quantity_sold)) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    const processExport = (export_type:string) => {
        setExportType(export_type);
        setOpenReportModal(true);
    }

    const generateReport = async (val:generalObj) => {
        if (!exportType || !id || !account || !account.isAuthenticated) return;

        setModalLoading(true);
        let date_from_obj = new Date(val.date_from);
        let date_to_obj = new Date(val.date_to);
        let param:generalObj = {
            type: exportType,
            date_from: date_from_obj.toISOString(),
            date_to: date_to_obj.toISOString(),
            store: id
        };
        
        if (rangeParam) {
            param.range = rangeParam;
        }

        let result = await fetchProductOrderParentListReport(account.token, param);

        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `product_order_parent_list.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            setExportType(null);
            setOpenReportModal(false);
            toast("Report generated");
        }
        setModalLoading(false);
    }

    return (
        <>
            <PageBodyHeader title="Product List" desc="Order details" >
                <button className="product_create_button" style={{color:"#FFF", backgroundColor:"#676967", borderColor:"#676967"}} onClick={() => navigate(`${UrlTypes.VENDOR_MENU}${id}`)}>
                    <span>Back</span>
                </button>
            </PageBodyHeader>

            <Table table_head={["Product", "Size", "SOH", "Open Stock", "Closing Stock", {
                element: <TableHeadElement title="Qty Sold" current_value={rangeParam} />
            }, {
                element: <TableHeadElement title="ROS" current_value={rangeParam} />
            }, "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            tableAction={account?.show_product_log && <ExportData export_type={(val) => processExport(val)} /> }
            headerStyle={{marginBottom: "44px"}}
            containerCardStyle={{minHeight:"200px"}}
            table_title={`Product report for ${storeName}`}
            >
                <>
                    {productList.map((item, index) => (
                        (item.show || item.show === undefined) && (
                            <tr key={index}>
                                <td>
                                    <div className="contentWithImg">
                                        <span><img src={item.image} alt={item.product} /></span>
                                        <span>{item.product}</span>
                                    </div>
                                </td>
                                <td>{item.size}</td>
                                <td>{item.quantity}</td>
                                <td>{item.open_stock}</td>
                                <td>{item.close_stock}</td>
                                <td>{item.quantity_sold}</td>
                                <td>{item.ros}</td>
                                <td>
                                    <div className="edit__delete_action">
                                        {account?.show_product_log && (
                                            <button onClick={() => navigate(`${UrlTypes.VENDOR_PRODUCT_SUB_LIST}${id}/${item.id}/`)} className={`status__container completed`} style={{width:"60px", padding:"5px", height:"auto"}}>
                                                View
                                            </button>
                                        )}
                                        {/* Removed as it's now conditionally rendered above */}
                                    </div>
                                </td>
                            </tr>
                        )
                    ))}
                </>
            </Table>
            
            {itemToDelete && <ConfirmationModal visible={openDeleteConfirmation} title={"Delete Confirmation"} description={`Do you want to delete Product order ${itemToDelete.product}?`} closeText="No" submitText="Yes" modalClose={() => {setItemToDelete(null); setOpenDeleteConfirmation(false)}} onSubmit={() => onDelete()} />}
            <ReportModal visible={openReportModal} modalClose={() => setOpenReportModal(false)} onAdded={(val) => generateReport(val)}  />
        </>
    )
}

export default VendorProductList;